
import "core-js/stable";
import "regenerator-runtime/runtime";
import { createApp } from 'ice';

const appConfig = {
  app: {
    rootId: 'ice-container',
  },
  router: {
    type: 'browser',
  }
};
createApp(appConfig);

  